// extracted by mini-css-extract-plugin
export default {"wrapper":"zk","form":"Ak","option":"Bk","radio":"Ck","success":"Dk","contest":"Ek"};